const config = {
    URL: 'https://meta-browser-api.khatsko.org',
    TEST_USER_WALLET: '0x263462e25018c092ac747237f6d81ee761de7643'
}


export default config;